import { axios } from 'lib/axios';

export const updateAdminPassword = (data) => {
  return axios.post('/auth/updatePassword', data);
};
